import BillsList from "../components/BillsList/BillsList";

export default function Bills() {
    return <BillsList />;
}
